import { Box, Button, Typography } from "@mui/material";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import { IPlanSubscriptions } from "../ModalSubscriptions"; // Ajuste o caminho se ModalSubscriptions estiver em outro lugar
import { useAuthContext } from "src/Contexts/AuthContext/authContext";
import { UseFormAbandonment } from "../Hooks/UseFormAbandonment";
import { useEffect } from "react";

interface SubscriptionSuccessProps {
  planSelected: IPlanSubscriptions;
  setOpenModal: () => void; // Função para fechar o modal
}

export const SubscriptionSuccess = ({
  planSelected,
  setOpenModal,
}: SubscriptionSuccessProps) => {
  const { setOpenModalFirst } = useAuthContext();

  const { handleSubmit } = UseFormAbandonment();

  useEffect(() => {
    handleSubmit({ event: "CHECKOUT_SUCCESS" });
  }, []);

  const handleOpenModalFirst = () => {
    setOpenModalFirst(true);
    setOpenModal();
  };

  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center",
        height: "100%",
        textAlign: "center",
        p: 4,
        gap: 3,
        bgcolor: "background.paper",
        borderRadius: "inherit",
      }}
    >
      <CheckCircleIcon sx={{ fontSize: 80, color: "success.main" }} />
      <Typography
        variant="h4"
        component="h2"
        sx={{
          fontWeight: "bold",
          color: "text.primary",
          fontSize: { xs: "20px", md: "30px" },
        }}
      >
        Cartão validado com sucesso!
      </Typography>
      <Typography variant="h6" sx={{ color: "text.secondary" }}>
        Parabéns! Seu plano <strong>{planSelected.title}</strong> foi ativado
        com sucesso.
      </Typography>
      <Typography variant="body1" sx={{ color: "text.secondary", mb: 3 }}>
        Explore todos os recursos agora mesmo e aproveite ao máximo sua nova
        assinatura.
      </Typography>
      <Button
        variant="contained"
        color="primary"
        size="large"
        onClick={handleOpenModalFirst}
        sx={{ borderRadius: "20px", px: 4, py: 1.5 }}
      >
        Começar a usar
      </Button>
    </Box>
  );
};
